export const ADMIN = 'ADMIN';
export const ALL = 'ALL';